module.exports = __webpack_public_path__ + "static/media/group-customer-auto.7d6b23f4.png";